export var VoucherFormat;
(function (VoucherFormat) {
    /** Format A: monthly reset — e.g. JV-2026-05-000182 */
    VoucherFormat["MonthlyReset"] = "A";
    /** Format B: yearly reset, YYMM embedded — e.g. PV-2605-000042 */
    VoucherFormat["YearlyResetYYMM"] = "B";
    /** Format C: yearly running, YYYY embedded — e.g. CIP-2026-000008 */
    VoucherFormat["YearlyRunning"] = "C";
    /** Lifetime IDs with no year component — e.g. C-00118, V-00284 */
    VoucherFormat["Lifetime"] = "L";
})(VoucherFormat || (VoucherFormat = {}));
/** Compose a voucher number string per spec 0.5. Not implemented in Phase 0. */
export function formatVoucherNumber(_opts) {
    throw new Error('formatVoucherNumber: not implemented (Phase 0 stub)');
}
/** Parse a voucher number back to its component parts. Not implemented in Phase 0. */
export function parseVoucherNumber(_voucherNo) {
    throw new Error('parseVoucherNumber: not implemented (Phase 0 stub)');
}
//# sourceMappingURL=voucher.js.map